import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TenantsMgmtComponent} from 'src/app/main/tenants-mgmt/tenants-mgmt.component';

const routes: Routes = [
  {
    path: '',
    component: TenantsMgmtComponent,
    children: []
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantsMgmtRoutingModule {
}
